var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/cdrobish/Development/ChadAndrewDrobish/four32c/holiday-map/development/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["holiday-map/templates/location.nunj"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<h1 class=\"no\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "no"), env.opts.autoescape);
output += "</h1>\n<div class=\"details\">\n    <h4 class=\"title\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += "</h4>\n    <p>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "description"), env.opts.autoescape);
output += "</p>\n    <div class=\"address\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "address_line1"), env.opts.autoescape);
output += "<br/>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "address_line2"), env.opts.autoescape);
output += "</div>\n    <ul class=\"social-links\">\n        \n        <li><a id=\"fb-link\" href=\"https://www.facebook.com/sharer/sharer.php?u=";
output += runtime.suppressValue(env.getFilter("urlencode").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "share")),"url")), env.opts.autoescape);
output += "\"><i class=\"fa fa-facebook\"></i></a></li>\n        <li><a id=\"twiiter-link\" href=\"https://twitter.com/intent/tweet?text=";
output += runtime.suppressValue(env.getFilter("urlencode").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "share")),"description")), env.opts.autoescape);
output += "&url=";
output += runtime.suppressValue(env.getFilter("urlencode").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "share")),"url")), env.opts.autoescape);
output += "\"><i class=\"fa fa-twitter\"></i></a></li>\n        <li><a id=\"linkedin-link\" href=\"https://www.linkedin.com/cws/share?url=";
output += runtime.suppressValue(env.getFilter("urlencode").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "share")),"url")), env.opts.autoescape);
output += "\"><i class=\"fa fa-linkedin\"></i></a></li>\n        <li><a href=\"mailto:?Subject=";
output += runtime.suppressValue(env.getFilter("urlencode").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "share")),"title")), env.opts.autoescape);
output += "&Body=";
output += runtime.suppressValue(env.getFilter("urlencode").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "share")),"description")), env.opts.autoescape);
output += "\"><i class=\"fa fa-envelope-o\"></i></a></li>\n    </ul>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["holiday-map/templates/location.nunj"] , dependencies)


/*****************
 ** WEBPACK FOOTER
 ** ./holiday-map/templates/location.nunj
 ** module id = 26
 ** module chunks = 0
 **/